module.exports = __webpack_public_path__ + "img/ButtonNFC.e2dc041e.jpg";